/// <reference path="../../public/jquery-1.6.2.min.js" />
/// <reference path="../../public/AJAX.js" />
/// <reference path="../../public/General.js" />
/// <reference path="../../public/Security.js" />
/// <reference path="../../public/ServiceURL.js" />
/// <reference path="../../SumoDataAccess.js" />
/// <reference path="../../SumoClass.js" />
/// <reference path="../ControlBase.js" />

// FilterControl Constructor Options (this.Options)
// Title: The header caption of the dialog
// Content: The header caption of the content space
// HideOnFilter: If true, the filter will hide when the filter button is clicked.
// OnFilter: The callback event for filter events, including clicking the filter button.
//           Paramters:
//                      SumoPredicateBuilder
// Columns: The column definitions required to build the filter UI elements and the query predicate
//          Properties:
//                      Id: the id suffix for the ui element that represents the column
//                      Title: the caption of the ui element that represents the column
//                      Type: the type of ui element that represents the column
//                            Valid Types: Text, Dropdown, CheckList, RadioList
//                      DataField: the name of the data field property of the object type being queried
//                      InsertBlank: add an empty item at the top of the dropdown
//                      DefaultValue: optional. the default value to use for the field, else the item will be left blank or unfiltered
//                      ComparisonType: the type of the default value - required because during predicate evaluation true == "true" is false.
//                                      supported values are Boolean and String
//          Sample Columns Definition:
//                      [
//                        { 'Id': 'SerialNumber', 'Title': 'Serial #', 'Type': 'Text', 'DataField': 'SerialNumber' },
//                        { 'Id': 'Product', 'Title': 'Product', 'Type': 'Dropdown', 'DataField': 'ProductId', 'DataSource': getDataItems('Products'), 'DataTextField': 'Name', 'DataValueField': 'Id', 'InsertBlank': true },
//                        { 'Id': 'Agency', 'Title': 'Agency', 'Type': 'Dropdown', 'DataField': 'OrganizationId', 'DataSource': getDataItems('Organizations'), 'DataTextField': 'Name', 'DataValueField': 'Id', 'InsertBlank': true },
//                        { 'Id': 'Status', 'Title': 'Status', 'Type': 'Dropdown', 'DataField': 'Status', 'DataSource': getDataItems('DeviceStatuses'), 'DataTextField': 'Name', 'DataValueField': 'Id', 'InsertBlank': true, 'DefaultValue': '5' } // 5 = UNASSIGNED
//                      ]
// Settings: Settings that determin the behavior of the dialog
//           SingleClick: if true, the dialog will auto-hide
//           Timeout: if SingleClick is true, then the dialog will auto- hide when the timeout is reached
//           (Note: SingleClick requires the TimerManager component)
//           DisplayInline: true/false
//           StartVisible: true/false

function FilterControl(aId, aParentId, aHtml, aOptions) {
    "use strict";

    FilterControl.prototype.baseClass.call(this, aId, aParentId,aHtml, aOptions);

    if (this.isNothing(SumoPredicateBuilder)) {
        throw (this.className() + ' requires SumoDataAccessLibrary.js.');
    }

    if (this.isNothing(this.Options)) {
        throw (this.className() + ': invalid call to constructor. no params passed to control id: ' + this.Id);
    }

    this.Title = '';
    this.Content = '';
    this.HideOnFilter = false;
    this.Columns = null;
    this.SecondaryColumns = null;
    this.Settings = null;
    this.Expression = null;
    this.UserPreferences = [];
    this.FilterState = [];
    this.ExpressionState = {};

    var mIsSingleClick = false,
        mTimeout = 500,
        mThis = this,
        mExpanderVisible = false,
        mTimerManager = null,
        mCssClass = '',
        mCheckListData = [],
        mDateFields = null,
        mUserId = -1,
        mFilterUserPreferencesCallback = null,
        mFilterLocalizableMethod = null,
        mAlignment = '',
        mUserPreferenceType = -1,
        mExpressionHash = {};

    if (!this.isNothing(this.Options.Title)) {
        this.Title = this.Options.Title;
    }
    if (!this.isNothing(this.Options.CssClass)) {
        mCssClass = this.Options.CssClass;
    }
    if (!this.isNothing(this.Options.Content)) {
        this.Content = this.Options.Content;
    }
    if (!this.isNothing(this.Options.HideOnFilter)) {
        this.HideOnFilter = this.Options.HideOnFilter;
    }
    if (!this.isNothing(this.Options.OnFilter)) {
        this.bind('filter', this.Options.OnFilter);
    }
    if (!this.isNothing(this.Options.Columns)) {
        this.Columns = this.Options.Columns;
    }
    if (!this.isNothing(this.Options.Settings)) {
        this.Settings = this.Options.Settings;
    }
    if (!this.isNothing(this.Options.UserPreferences)) {
        this.UserPreferences = this.Options.UserPreferences;
    }
    if (!this.isNothing(this.Options.UserPreferenceType)) {
        mUserPreferenceType = this.Options.UserPreferenceType;
    }
    if (!this.isNothing(this.Options.UserId)) {
        mUserId = this.Options.UserId;
    }
    if (!this.isNothing(this.Options.CallbackClick)) {
        mFilterUserPreferencesCallback = this.Options.CallbackClick;
    }
    if (!this.isNothing(this.Options.LocalizableMethod)) {
        mFilterLocalizableMethod = this.Options.LocalizableMethod;
    }
    if (!this.isNothing(this.Options.Alignment)) {
        mAlignment = this.Options.Alignment;
    }

    function isSingleClick() {
        var lResult = false;
        if ((!mThis.isNothing(mThis.Settings)) && (!mThis.isNothing(mThis.Settings.SingleClick))) {
            lResult = mThis.Settings.SingleClick;
        }
        return lResult;
    }

    mIsSingleClick = isSingleClick(this);
    if ((!this.isNothing(this.Settings)) && (!this.isNothing(this.Settings.Timeout))) {
        mTimeout = this.Settings.Timeout;
    }
    if (mIsSingleClick && !this.isNothing(TimerManager)) {
        mTimerManager = new TimerManager(mTimeout);
    } else if (mIsSingleClick && this.isNothing(mTimerManager)) {
        throw (this.className() + ': single click isn\'t supported unless the TimerManager code is loaded.');
    }

    function toggleArrow(aDirection) {
        var lArrow = $('#' + mThis.Id + 'Arrow');
        if (aDirection === 'right') {
            lArrow.removeClass('Down').addClass('Right');
        } else {
            lArrow.removeClass('Right').addClass('Down');
        }
    }

    this.hide = function () {
        mExpanderVisible = false;
        toggleArrow('right');
        $('#' + this.Id + 'Expander').fadeOut();
    };

    this.show = function () {
        mExpanderVisible = true;
        toggleArrow('down');
        $('#' + this.Id + 'Expander').fadeIn();
    };

    this.toggleExpander = function () {
        if (mExpanderVisible) {
            this.hide();
        } else {
            this.show();
        }
    };

    function getValue(aColumn) {
        var lValue,
            lItemList = $('input[name=' + mThis.Id + aColumn.Id + ']:checked'),
            i,
            j,
            lData,
            lValueList = [],
            lIdList = [];
        switch (aColumn.Type) {
            case 'Text':
                lValue = $('#' + mThis.Id + aColumn.Id).val();
                break;
            case 'Date':
                lValue = $('#' + mThis.Id + aColumn.Id).val();
                if (!mThis.isNothing(lValue) && lValue !== '') {
                    lValue = Date.parse(lValue);
                    if (!isNaN(lValue)) {
                        lValue = new Date(lValue);
                    } else {
                        lValue = null;
                    }
                } else {
                    lValue = null;
                }
                break;
            case 'Dropdown':
                lValue = $('#' + mThis.Id + aColumn.Id).val();
                if (!mThis.isNothing(lValue) && lValue !== '') {
                    if (!mThis.isNothing(aColumn.ComparisonType)) {
                        switch (aColumn.ComparisonType.toString().toLowerCase()) {
                            case 'boolean':
                                lValue = (lValue.toLowerCase() === 'true' || lValue.toString().toLowerCase() === '1');
                                break;
                            case 'string':
                                lValue = lValue.toString();
                                break;
                            case 'integer':
                                lValue = parseInt(lValue);
                                break;
                        }
                    }
                }
                break;
            case 'CheckList':
                if (lItemList.length > 0) {
                    for (i = 0; i < lItemList.length; i++) {
                        // if it has a related data element, then loop it in here too
                        lData = $('#' + lItemList[i].id);

                        lValue = lData.val();
                        if (!mThis.isNothing(lValue) && lValue !== '') {
                            lValueList.push(lValue);
                        }

                        //if (!mThis.isNothing(lData)) {
                        //    for (j = 0; j < lData.length; j++) {
                        //        lValueList.push(lData[j].val());
                        //    }
                        //} else {
                        //    lValueList.push(lItemList[i].value);
                        //}
                    }
                }
                lValue = lValueList;
                break;
            case 'RadioList':
                lValue = $('input[name=' + mThis.Id + aColumn.Id + ']:checked').val();
                break;
        }
        return lValue;
    }

    function setValue(aColumn, aValue) {
        var lDataSource = aColumn.DataSource,
            lDataItem,
            lKey;

        switch (aColumn.Type) {
            case 'Text':
            case 'Date':
            case 'Dropdown':
                $('#' + mThis.Id + aColumn.Id).val(aValue).change();
                break;
            case 'CheckList':
                for (lKey in lDataSource) {
                    if (lDataSource.hasOwnProperty(lKey)) {
                        lDataItem = lDataSource[lKey];
                        if (aValue.indexOf(lDataItem[aColumn.DataValueField].toString()) !== -1) {
                            $('#' + mThis.Id.toString() + aColumn.Id.toString() + lDataItem.Id.toString()).attr('checked', true).change();
                        } else {
                            $('#' + mThis.Id.toString() + aColumn.Id.toString() + lDataItem.Id.toString()).removeAttr('checked').change();
                        }
                    }
                }
                break;
            case 'RadioList':
                break;
        }
    }

    // EXPRESSION
    function buildPredicate() {
        var lKey,
            lColumn,
            lColumns = mThis.Columns,
            lValue = '',
            lRelationalOperator,
            lPredicateBuilder = new SumoPredicateBuilder(),
            lExpressionBuilder = new SumoPredicateBuilder(),
            lPreference = new UserPreference(),
            lDoSaveState = false;

        mThis.FilterState = [];
        mThis.ExpressionState = {};
        for (lKey in lColumns) {
            if (lColumns.hasOwnProperty(lKey)) {
                lColumn = lColumns[lKey];
                lPreference = new UserPreference();
                lPreference.UserPreferenceType = mUserPreferenceType;
                lPreference.Id = mUserId;
                lRelationalOperator = lColumn.relationalOperator;
                switch (lColumn.Type) {
                    case 'Text':
                        lValue = $('#' + mThis.Id + lColumn.Id).val();
                        lPreference.Value = lValue;
                        lPreference.ColumnName = lColumn.Id;
                        if (!mThis.isNothing(lValue) && lValue !== '') {
                            if (mThis.isNothing(lRelationalOperator)) {
                                lRelationalOperator = mRelationalOperatorEnum.Like();
                            }
                            if (!mThis.isNothing(lColumn.ComparisonType)) {
                                switch (lColumn.ComparisonType.toString().toLowerCase()) {

                                    case 'number':
                                        lValue = parseInt(lValue);
                                        if (isNaN(lValue))
                                            lValue = '';
                                        break;
                                }
                            }
                            if(lValue !== '')
                                lExpressionBuilder.AddNewExpressionConditional(lColumn.DataField, lValue, false, lRelationalOperator, mLogicalOperatorEnum.And());
                        }
                        break;
                    case 'DoubleMinMaxText':
                        lValue = $('#' + mThis.Id + lColumn.Id+1).val();
                        var lValue2 = $('#' + mThis.Id + lColumn.Id + 2).val();

                        if (!!mThis.isNothing(lValue)) {
                            if (lValue > 0) {
                                lExpressionBuilder.AddNewExpressionConditional(lColumn.DataField, lValue, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
                            }
                        }
                        else {
                            lValue = 0;
                        }
                        if (!!mThis.isNothing(lValue2)) {
                            if (lValue2 > lValue) {
                                lExpressionBuilder.AddNewExpressionConditional(lColumn.DataField, lValue, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
                            }
                        }
                        break;
                    case 'Date':
                        lValue = $('#' + mThis.Id + lColumn.Id).val();
                        lPreference.Value = lValue;
                        lPreference.ColumnName = lColumn.Id;
                        if (!mThis.isNothing(lValue) && lValue !== '') {
                            lValue = Date.parse(lValue);
                            if (!isNaN(lValue)) {
                                lValue = new Date(lValue);
                                if (mThis.isNothing(lRelationalOperator)) {
                                    lRelationalOperator = mRelationalOperatorEnum.Equal();
                                }
                                if (lRelationalOperator === mRelationalOperatorEnum.LessThan() || lRelationalOperator === mRelationalOperatorEnum.LessThanOrEqual()) {
                                    lValue = new Date(lValue.setDate(lValue.getDate() + 1));
                                }
                                lExpressionBuilder.AddNewExpressionConditional(lColumn.DataField, lValue, false, lRelationalOperator, mLogicalOperatorEnum.And());
                            }
                        }
                        break;
                    case 'Dropdown':
                        lValue = $('#' + mThis.Id + lColumn.Id).val();
                        if (!mThis.isNothing(lValue) && lValue !== '') {
                            if (!mThis.isNothing(lColumn.ComparisonType)) {
                                switch (lColumn.ComparisonType.toString().toLowerCase()) {
                                    case 'boolean':
                                        lValue = (lValue.toLowerCase() === 'true' || lValue.toString().toLowerCase() === '1');
                                        break;
                                    case 'string':
                                        lValue = lValue.toString();
                                        break;
                                    case 'integer':
                                        lValue = parseInt(lValue);
                                        break;
                                    //                                    number
                                    //                                    object
                                    //                                    function
                                    //                                    null
                                    //                                    undefined
                                }
                            }
                            if (mThis.isNothing(lRelationalOperator)) {
                                lRelationalOperator = mRelationalOperatorEnum.Equal();
                            }

                            if ((!mThis.isNothing(lColumn.IgnoreValue) && lColumn.IgnoreValue != lValue) || mThis.isNothing(lColumn.IgnoreValue))
                                lExpressionBuilder.AddNewExpressionConditional(lColumn.DataField, lValue, false, lRelationalOperator, mLogicalOperatorEnum.And());

                        } else {
                            lValue = '';
                        }
                        lPreference.Value = lValue;
                        lPreference.ColumnName = lColumn.Id;
                        break;
                    case 'DoubleDropDown':
                        lValue = $('#' + mThis.Id + lColumn.Id + '1').val();
                        var lValue2 = $('#' + mThis.Id + lColumn.Id + '2').val(),
                            lFinalValue = 0;

                        if (!mThis.isNothing(lValue) && lValue !== '') {
                            switch (lColumn.ComparisonType.toString().toLowerCase()) {
                                case 'string':
                                    lValue = lValue.toString();
                                    lValue2 = lValue2.toString();
                                    break;
                                case 'integer':
                                    lValue = parseInt(lValue);
                                    lValue2 = parseInt(lValue2);
                                    break;
                            }
                            if (!isNullOrUndefined(lColumn.ActualType)) {
                                if (lColumn.ActualType == 'Measurement') {
                                    lFinalValue = (parseInt(lValue * 12) + parseInt(lValue2));
                                }
                            }
                            if (mThis.isNothing(lRelationalOperator)) {
                                lRelationalOperator = mRelationalOperatorEnum.Equal();
                            }
                            if (lFinalValue > 0) {
                                lExpressionBuilder.AddNewExpressionConditional(lColumn.DataField, lFinalValue, false, lRelationalOperator, mLogicalOperatorEnum.And());
                            }
                        }
                        break;
                    case 'CheckList':
                        var lItemList = $('input[name=' + mThis.Id + lColumn.Id + ']:checked'),
                            i, j, lData,
                            lValueList = [],
                            lIdList = [];
                        if (lItemList.length > 0) {
                            for (i = 0; i < lItemList.length; i++) {
                                // if it has a related data element, then loop it in here too
                                lData = mCheckListData[lItemList[i].id];
                                lIdList.push(lItemList[i].value);
                                if (!mThis.isNothing(lData)) {
                                    for (j = 0; j < lData.length; j++) {
                                        lValueList.push(lData[j]);
                                    }
                                } else {
                                    lValueList.push(lItemList[i].value);
                                }
                            }
                            //validated on line 202  if (lItemList.length > 0) {
                            if (mThis.isNothing(lRelationalOperator)) {
                                lRelationalOperator = mRelationalOperatorEnum.In();
                            }
                            lExpressionBuilder.AddNewExpressionConditional(lColumn.DataField, lValueList, false, lRelationalOperator, mLogicalOperatorEnum.And());
                            //lIdList = lItemList.valueOf();
                        } else {
                            //this code makes the system work the way no one would ever expect it to
                            //lExpressionBuilder.AddNewExpressionConditional(lColumn.DataField, [-99999], false, lRelationalOperator, mLogicalOperatorEnum.And());
                        }
                        lPreference.Value = JSON.stringify(lIdList);
                        lPreference.ColumnName = lColumn.Id;
                        break;
                    case 'RadioList':
                        lValue = $('input[name=' + mThis.Id + lColumn.Id + ']:checked').val();
                        if (!mThis.isNothing(lValue) && lValue !== '') {
                            if (mThis.isNothing(lRelationalOperator)) {
                                lRelationalOperator = mRelationalOperatorEnum.Equal();
                            }
                            lExpressionBuilder.AddNewExpressionConditional(lColumn.DataField, lValue, false, lRelationalOperator, mLogicalOperatorEnum.And());
                        }
                        break;
                }
                mExpressionHash[lColumn.Id] = lExpressionBuilder.RootExpression;
                if (!isNullOrUndefined(lExpressionBuilder.RootExpression)) {
                    lPredicateBuilder.AddConditional(lExpressionBuilder.RootExpression, mLogicalOperatorEnum.And());
                }
                lExpressionBuilder.Clear();

                lDoSaveState = lColumn.doSaveState;
                if (mThis.isNothing(lColumn.doSaveState)) {
                    lDoSaveState = true;
                }
                if (lDoSaveState) {
                    mThis.FilterState.push(lPreference);
                }
                mThis.ExpressionState[lPreference.ColumnName] = lPreference;
            }
        }
        return lPredicateBuilder.RootExpression;
    }

    function doClear() {
        if (!mThis.isNothing(mTimerManager)) {
            mTimerManager.StopTimer();
        }
        // reset the filter to default condition

        var lKey,
            lCheckKey,
            lCheckItem,
            lColumn,
            lColumns = mThis.Columns;
        $('.'+mThis.Id+'TextBox').val('');
        $('.'+mThis.Id+'Dropdown').val('');
        for (lKey in lColumns) {
            if (lColumns.hasOwnProperty(lKey)) {
                lColumn = lColumns[lKey];
                if (!mThis.isNothing(lColumn.DefaultValue)) {
                    if (lColumn.Type === 'CheckList') {
                        for (lCheckKey in lColumn.DataSource) {
                            if (lColumn.DataSource.hasOwnProperty(lCheckKey)) {
                                lCheckItem = lColumn.DataSource[lCheckKey];
                                if (!mThis.isNothing(lColumn.DefaultValue) && lColumn.DefaultValue.indexOf(lCheckItem[lColumn.DataValueField]) !== -1) {
                                    $('div.FilterControlContent #' + mThis.Id + lColumn.Id + lCheckItem[lColumn.DataValueField]).attr('checked', true);
                                } else {
                                    $('div.FilterControlContent #' + mThis.Id + lColumn.Id + lCheckItem[lColumn.DataValueField]).attr('checked', false);
                                }
                            }
                        }
                    } else {
                        $('div.FilterControlContent #' + mThis.Id + lColumn.Id).val(lColumn.DefaultValue.toString());
                        if (lColumn.Type === 'Dropdown') {
                            $('div.FilterControlContent #' + mThis.Id + lColumn.Id).change();
                        }
                    }
                } else {
                    if (lColumn.Type === 'CheckList') {
                        for (lCheckKey in lColumn.DataSource) {
                            if (lColumn.DataSource.hasOwnProperty(lCheckKey)) {
                                lCheckItem = lColumn.DataSource[lCheckKey];
                                $('div.FilterControlContent #' + mThis.Id + lColumn.Id + lCheckItem[lColumn.DataValueField]).attr('checked', false);
                            }
                        }
                    } else if (lColumn.Type === 'Dropdown') {
                        $('div.FilterControlContent #'+ mThis.Id + lColumn.Id).change();
                    }
                }
            }
        }
    }

    function doFilter(aIsClicked) {
        if (!mThis.isNothing(mTimerManager)) {
            mTimerManager.StopTimer();
        }
        mThis.Expression = buildPredicate();
        if (aIsClicked) {
            FreeFormFilterUserPreferences(mThis);
            if(mFilterUserPreferencesCallback)
                mFilterUserPreferencesCallback();
        }
        mThis.trigger('filter', mThis.Expression);
    }

    function getDefaultValue(aColumn, aDefault) {
        var lDefault = null,
            lDoSaveState = aColumn.doSaveState;
        if (mThis.isNothing(aColumn.doSaveState)) {
            lDoSaveState = true;
        }
        //if (lDoSaveState && !mThis.isNothing(mThis.UserPreferences[aColumn.Id])) {
        if (!mThis.isNothing(mThis.UserPreferences[aColumn.Id])) {
            lDefault = mThis.UserPreferences[aColumn.Id].Value;
        } else if (!mThis.isNothing(aColumn.DefaultValue)) {
            lDefault = aColumn.DefaultValue;
        }
        if(!mThis.isNothing(aColumn.IsNullCheckAll)){
            if (isNullOrUndefined(lDefault) || lDefault == '[]') {
                lDefault = aColumn.DefaultValue
            }
        }
        return lDefault;
    }

    function generateTextBox(aColumn) {
        var lTextBox = null,
            lDefault = getDefaultValue(aColumn, '');
        lTextBox = $('<input/>', {
            'type': 'text',
            'value': lDefault,
            'id': mThis.Id + aColumn.Id,
            'class': mThis.Id+'TextBox'
        });
        if (mIsSingleClick && !mThis.isNothing(mTimerManager)) {
            lTextBox.change(function () {
                mTimerManager.SetTimer(function () { doFilter(); });
            });
        }
        lTextBox.change(aColumn.Id, function (aEvent) {
            mThis.trigger(aEvent.data + 'changed', aEvent);
        });
        return lTextBox;
    }

    function generateDoubleMinMaxTextBox(aColumn) {
        var lTextBox1,
            lTextBox2;

        lTextBox1 = $('<input/>', {
            'type': 'text',
            'placeholder': 'Min',
            'id': mThis.Id + aColumn.Id+1,
            'class': mThis.Id + 'TextBox'
        });
        lTextBox2 = $('<input/>', {
            'type': 'text',
            'placeholder': 'Max',
            'id': mThis.Id + aColumn.Id+2,
            'class': mThis.Id + 'TextBox'
        });


        return [lTextBox1, lTextBox2];
    }
    function generateDateBox(aColumn) {
        var lTextBox = null,
            lDefault = getDefaultValue(aColumn,'');
        lTextBox = $('<input/>', {
            'type': 'text',
            'value': lDefault,
            'id': mThis.Id + aColumn.Id,
            'class': 'DatePick'
        });
        mDateFields.push(mThis.Id + aColumn.Id);
        if (mIsSingleClick && !mThis.isNothing(mTimerManager)) {
            lTextBox.change(function () {
                mTimerManager.SetTimer(function () { doFilter(); });
            });
        }
        lTextBox.change(aColumn.Id, function (aEvent) {
            mThis.trigger(aEvent.data + 'changed', aEvent);
        });
        return lTextBox;
    }

    function generateDoubleDropdown(aColumn) {
        var lSelect = $('<select/>', {
            'id': mThis.Id + aColumn.Id + '1', 'class': mThis.Id + 'Dropdown'
        }),
        lSelect2 = $('<select/>', {
            'id': mThis.Id + aColumn.Id + '2', 'class': mThis.Id + 'Dropdown'
        }),
        lDefault = getDefaultValue(aColumn, null);

        lSelect = generateDropDownList(lSelect, aColumn.DataSource);
        lSelect2 = generateDropDownList(lSelect2, aColumn.DataSource2);

        function generateDropDownList(aSelect, aDataSource) {
            var lKey,
                lSelectOption,
                newSelect = aSelect,
                lDataSource = aDataSource,
                lDataItem,
                lBlankText = '';

            if (!mThis.isNothing(aColumn.InsertBlank) && aColumn.InsertBlank) {
                if (!mThis.isNothing(aColumn.BlankText)) {
                    lBlankText = aColumn.BlankText;
                }
                lSelectOption = $('<option/>', {
                    'value': '',
                    'text': lBlankText
                });
                if (mIsSingleClick && !mThis.isNothing(mTimerManager)) {
                    lSelectOption.change(function () {
                        mTimerManager.SetTimer(function () { doFilter(); });
                    });
                }
                lSelectOption.appendTo(newSelect);
            }

            for (lKey in lDataSource) {
                if (lDataSource.hasOwnProperty(lKey)) {
                    lDataItem = lDataSource[lKey];

                    // double equals on purpose
                    if (!mThis.isNothing(aColumn.DefaultValue) && aColumn.DefaultValue == lDataItem[aColumn.DataValueField]) {
                        lSelectOption = $('<option/>', {
                            'id': 'option' + mThis.Id + aColumn.Id,
                            'class': 'default',
                            'value': lDataItem[aColumn.DataValueField],
                            'text': lDataItem[aColumn.DataTextField]
                        });
                    }
                    else {
                        lSelectOption = $('<option/>', {
                            'id': 'option' + mThis.Id + aColumn.Id,
                            'value': lDataItem[aColumn.DataValueField],
                            'text': lDataItem[aColumn.DataTextField]
                        });
                    }
                    if (mIsSingleClick && !mThis.isNothing(mTimerManager)) {
                        lSelectOption.change(function () {
                            mTimerManager.SetTimer(function () { doFilter(); });
                        });
                    }
                    lSelectOption.appendTo(newSelect);
                }
            }

            if (!mThis.isNothing(lDefault)) {
                newSelect.val(lDefault.toString());
            }
            newSelect.change(aColumn.Id, function (aEvent) {
                mThis.trigger(aEvent.data + 'changed', aEvent);
            });

            return newSelect;
        }

        return [lSelect,lSelect2];
    }

    function generateDropdown(aColumn) {
        var lSelect = $('<select/>', {
            'id': mThis.Id + aColumn.Id, 'class': mThis.Id + 'Dropdown'
        }),
            lKey,
            lSelectOption,
            lDataSource = aColumn.DataSource,
            lDataItem,
            lLocaleName = aColumn.LocaleName,
            lDefault = getDefaultValue(aColumn, null),
            lBlankText = '';

        if (!mThis.isNothing(aColumn.InsertBlank) && aColumn.InsertBlank) {
            if (!mThis.isNothing(aColumn.BlankText)) {
                lBlankText = aColumn.BlankText;
            }
            lSelectOption = $('<option/>', {
                'value': '',
                'text': lBlankText
            });
            if (mIsSingleClick && !mThis.isNothing(mTimerManager)) {
                lSelectOption.change(function () {
                    mTimerManager.SetTimer(function () { doFilter(); });
                });
            }
            lSelectOption.appendTo(lSelect);
        }

        for (lKey in lDataSource) {
            if (lDataSource.hasOwnProperty(lKey)) {
                lDataItem = lDataSource[lKey];

                // double equals on purpose
                if (!mThis.isNothing(aColumn.DefaultValue) && aColumn.DefaultValue == lDataItem[aColumn.DataValueField]) {
                    lSelectOption = $('<option/>', {
                        'id': 'option' + mThis.Id + aColumn.Id,
                        'class': 'default',
                        'value': lDataItem[aColumn.DataValueField],
                        'html': lDataItem[aColumn.DataTextField]
                    });
                    //console.log(lDataItem[aColumn.DataValueField]);
                }
                else {
                    var lHtmlValue = lDataItem[aColumn.DataTextField];
                    if (lLocaleName && mFilterLocalizableMethod) {
                        lHtmlValue = mFilterLocalizableMethod(lLocaleName, lHtmlValue);
                    }
                    lSelectOption = $('<option/>', {
                        'id': 'option' + mThis.Id + aColumn.Id,
                        'value': lDataItem[aColumn.DataValueField],
                        'html': lHtmlValue
                    });
                   // console.log(lDataItem[aColumn.DataValueField]);
                }
                if (mIsSingleClick && !mThis.isNothing(mTimerManager)) {
                    lSelectOption.change(function () {
                        mTimerManager.SetTimer(function () { doFilter(); });
                    });
                }
                lSelectOption.appendTo(lSelect);
            }
        }

        if (!mThis.isNothing(lDefault)) {
            lSelect.val(lDefault.toString());
        }
        lSelect.change(aColumn.Id, function (aEvent) {
            mThis.trigger(aEvent.data + 'changed', aEvent);
        });

        return lSelect;
    }

    //function generateCheckBox(aColumn) {
    //    "use strict";

    //    var lMasterDiv = $('<div/>', {
    //        'class': 'FilterControlRow'
    //    }),
    //        lDataItem =
    //        lKey = null,
    //        lRowDiv = $('<div/>', {}),
    //        lCheckbox = $('<input/>',{
    //            'type': 'checkbox',
    //            'name': mThis.Id.toString() + aColumn.Id.toString(),
    //            'id' : mThis.Id.toString() + aColumn.Id.toString() + lDataItem.
    //        }),
    //    lRowDiv = null,
    //    lCheckbox = null,
    //    lLabel = null,
    //    lDataSource = aColumn.DataSource,
    //    lDataItem = null,
    //    lDefault = getDefaultValue(aColumn, null);

    //    if (typeof lDefault == 'string') {
    //        lDefault = JSON.parse(lDefault);
    //    }

    //    lC
    //}

    function generateCheckList(aColumn) {
        var lMasterDiv = $('<div/>', {
            'class': 'FilterControlRow'
        }),
            lKey = null,
            lRowDiv = null,
            lCheckbox = null,
            lLabel = null,
            lDataSource = aColumn.DataSource,
            lDataItem = null,
            lDefault = getDefaultValue(aColumn, null);

        if (typeof lDefault === 'string') {
            lDefault = $.parseJSON(lDefault);
            if (isNullOrUndefined(lDefault)) {
                lDefault = '';
            }
            //lDefault = JSON.parse(lDefault);
        }

        for (lKey in lDataSource) {
            if (lDataSource.hasOwnProperty(lKey)) {
                lDataItem = lDataSource[lKey];
                lRowDiv = $('<div/>', {});
                lCheckbox = $('<input/>', {
                    'type': 'checkbox',
                    'name': mThis.Id.toString() + aColumn.Id.toString(),
                    'id': mThis.Id.toString() + aColumn.Id.toString() + lDataItem.Id.toString(),
                    'value': lDataItem[aColumn.DataValueField]
                });
                if (!mThis.isNothing(lDefault) && (lDefault.indexOf(lDataItem[aColumn.DataValueField].toString()) !== -1 || lDefault.indexOf(lDataItem[aColumn.DataValueField].toString()) !== -1)) {
                    $(lCheckbox).attr('checked', true);
                }
                if (!mThis.isNothing(lDataItem.data)) {
                    mCheckListData[mThis.Id.toString() + aColumn.Id.toString() + lDataItem.Id.toString()] = lDataItem.data;
                }
                lCheckbox.change({ 'Column': aColumn.Id, 'Item': lDataItem.Id }, function (aEvent) {
                    mThis.trigger(aEvent.data.Column + 'changed', aEvent);
                    mThis.trigger(aEvent.data.Column + aEvent.data.Item + 'changed', aEvent);
                });
                if (mIsSingleClick && !mThis.isNothing(mTimerManager)) {
                    lCheckbox.change(function () {
                        mTimerManager.SetTimer(function () { doFilter(); });
                    });
                }
                lLabel = $('<label/>', {
                    'for': mThis.Id + aColumn.Id + lDataItem.Id,
                    'text': lDataItem[aColumn.DataTextField]
                });
                lCheckbox.appendTo(lRowDiv);
                lLabel.appendTo(lRowDiv);
                lRowDiv.appendTo(lMasterDiv);
            }
        }
        return lMasterDiv;
    }

    function generateRadioList(aColumn) {
        var lMasterDiv = $('<div/>', {
            'class': 'FilterControlRow'
        }),
            lRowDiv,
            lRadiobox,
            lLabel,
            lDataSource = aColumn.DataSource,
            lDataItem,
            lKey,
            lDefault = getDefaultValue(aColumn, null),
            lCheckbox;

        if (!mThis.isNothing(lDefault)) {
            alert('default values not implemented for radio button list');
        }

        for (lKey in lDataSource) {
            if (lDataSource.hasOwnProperty(lKey)) {
                lDataItem = lDataSource[lKey];
                lRowDiv = $('<div/>', {});
                lRadiobox = $('<input/>', {
                    'type': 'radio',
                    'name': mThis.Id + aColumn.Id,
                    'id': mThis.Id + aColumn.Id + lDataItem.Id,
                    'value': lDataItem[aColumn.DataValueField]
                });
                lCheckbox.change({ 'Column': aColumn.Id, 'Item': lDataItem.Id }, function (aEvent) {
                    mThis.trigger(aEvent.data.Column + 'changed', aEvent);
                    mThis.trigger(aEvent.data.Column + aEvent.data.Item + 'changed', aEvent);
                });
                if (mIsSingleClick && !mThis.isNothing(mTimerManager)) {
                    lRadiobox.change(function () {
                        mTimerManager.SetTimer(function () { doFilter(); });
                    });
                }
                lLabel = $('<label/>', {
                    'for': mThis.Id + aColumn.Id + lDataItem.Id,
                    'text': lDataItem[aColumn.DataTextField]
                });
                lRadiobox.appendTo(lRowDiv);
                lLabel.appendTo(lRowDiv);
                lRowDiv.appendTo(lMasterDiv);
            }
        }
        return lMasterDiv;
    }

    function generateNewFilterRow(aColumn) {
        var lRow = $('<tr/>', {
            'class': 'FilterControlRow'
        }),
        lTitleCell = $('<td/>', {
            'class': 'FilterControlTitle',
            'html': aColumn.Title
        }),
        lContentCell = $('<td/>', {
            'class': 'FilterControlContent',
            'id': aColumn.Id + 'DataHolder'
        }),
        lContent = null;

        switch (aColumn.Type.toLowerCase()) {
            case 'text':
                lContent = generateTextBox(aColumn);
                break;
            case 'date':
                lContent = generateDateBox(aColumn);
                break;
            case 'dropdown':
                lContent = generateDropdown(aColumn);
                break;
            case 'doubledropdown':
                lContent = generateDoubleDropdown(aColumn);
                break;
            case 'doubleminmaxtext':
                lContent = generateDoubleMinMaxTextBox(aColumn);
                break;
            case 'checklist':
                lContent = generateCheckList(aColumn);
                break;
            case 'checkbox':
                lContent = generateCheckBox(aColumn);
                break;
            case 'radiolist':
                lContent = generateRadioList(aColumn);
                break;
        }
        if (!mThis.isNothing(lContent) && lContent.length < 2) {
            lContent.appendTo(lContentCell);
        }
        else if (lContent.length == 2) {
            lContent[0].appendTo(lContentCell);
            lContent[1].appendTo(lContentCell);
        }
        lTitleCell.appendTo(lRow);
        lContentCell.appendTo(lRow);
        return lRow;
    }

    function header_OnClick(aEvent) {
        aEvent.stopImmediatePropagation();
        mThis.toggleExpander();
    }

    function filterButton_OnClick(aEvent) {
        aEvent.stopImmediatePropagation();
        if (mThis.HideOnFilter) {
            mThis.hide();
        }
        doFilter(true);
    }

    function filterButton_OnEnter(aEvent) {
        aEvent.stopImmediatePropagation();
        //if event is enter key else if esc key hide filter
        if (aEvent.keyCode == 13) {
            if (mThis.HideOnFilter) {
                mThis.hide();
            }
            doFilter(true);
        } else if (aEvent.keyCode == 27) {
            mThis.hide();
        }
    }

    function resetButton_OnClick(aEvent) {
        aEvent.stopImmediatePropagation();
        doClear();
    }

    this.filter = function () {
        doFilter();
    };

    this.render = function () {
        var lBaseElement,
            lTable,
            lKey,
            lColumn,
            lRow,
            lHtml = this.Html;

        if (!this.isNothing(this.Settings) && !this.isNothing(this.Settings.DisplayInline) && this.Settings.DisplayInline) {
            lHtml = lHtml.replace(/##expandertype##/g, 'FilterControlExpanderInline');
        } else {
            lHtml = lHtml.replace(/##expandertype##/g, 'FilterControlExpanderFloat');
        }
        lHtml = lHtml.replace(/##title##/g, this.Title);
        lHtml = lHtml.replace(/##content##/g, this.Content);
        $('#' + aParentId).html(lHtml);

        $('#' + this.Id).data('control', this);
        $('#' + this.Id + 'Header').click(header_OnClick);
        $('#' + this.Id + 'FilterButton').click(filterButton_OnClick);
        $('#' + this.Id + 'ResetButton').click(resetButton_OnClick);
        $('#' + this.Id + 'Expander').addClass(mAlignment);
        lBaseElement = $('div #' + this.Id + 'Content').first();
        lTable = $('<table/>', {
            'class': 'FilterControl'
        });

        mCheckListData = [];
        mDateFields = [];
        for (lKey in this.Columns) {
            if (this.Columns.hasOwnProperty(lKey)) {
                lColumn = this.Columns[lKey];
                lRow = generateNewFilterRow(lColumn);
                lRow.appendTo(lTable);
            }
        }
        lBaseElement.html('');
        lTable.appendTo(lBaseElement);
        for (lKey in mDateFields) {
            if (mDateFields.hasOwnProperty(lKey)) {
                populateDateView('#' + mDateFields[lKey], null);
            }
        }

        for (lKey in this.Columns) {
            if (this.Columns.hasOwnProperty(lKey)) {
                lColumn = this.Columns[lKey];
                $("#" + this.Id + lColumn.Id).keyup(filterButton_OnEnter);
            }
        }

        $('#' + this.Id).addClass(mCssClass);
        veritracks.localization.localize('#' + this.Id); // add localize
        this.trigger('render');
    };

    this.init = function () {
        var lColumn,
            lKey;
        for (lKey in this.Columns) {
            if (this.Columns.hasOwnProperty(lKey)) {
                lColumn = this.Columns[lKey];

                if (lColumn.Type === 'Dropdown') {
                    $('div.FilterControlContent #' + mThis.Id + lColumn.Id).change();
                }
            }
        }
    }

    this.setColumnDataSource = function (aColumnId, aData) {
        var lContentCell = $('#'+aColumnId + 'DataHolder'),
            lContent,
            lItem,
            lKey;
        if (lContentCell.length === 1) {
            for (lKey in this.Columns) {
                if (this.Columns.hasOwnProperty(lKey)) {
                    lItem = this.Columns[lKey];
                    if (lItem.Id === aColumnId) {
                        lItem.DataSource = aData;
                        switch (lItem.Type.toLowerCase()) {
                            case 'text':
                                lContent = generateTextBox(lItem);
                                break;
                            case 'date':
                                lContent = generateDateBox(lItem);
                                break;
                            case 'dropdown':
                                lContent = generateDropdown(lItem);
                                break;
                            case 'checklist':
                                lContent = generateCheckList(lItem);
                                break;
                            case 'checkbox':
                                lContent = generateCheckBox(lItem);
                                break;
                            case 'radiolist':
                                lContent = generateRadioList(lItem);
                                break;
                        }
                        if (!mThis.isNothing(lContent)) {
                            lContentCell.html('');
                            lContent.appendTo(lContentCell);
                        }
                    }
                }
            }
        }
    };

    this.getColumnExpression = function (aColumnName) {
        var lResult = null;

        if (!mThis.isNothing(mExpressionHash[aColumnName])) {
            lResult = mExpressionHash[aColumnName];
        }

        return lResult;
    };

    this.columnValue = function (aColumnName, aValue) {
        var lResult = null,
            lColumn,
            lItem,
            lKey;

        for (lKey in mThis.Columns) {
            if (mThis.Columns.hasOwnProperty(lKey)) {
                lItem = mThis.Columns[lKey];
                if (lItem.Id === aColumnName) {
                    lColumn = lItem;
                    break;
                }
            }
        }

        if (mThis.isNothing(aValue)) {
            lResult = getValue(lColumn);
        } else {
            setValue(lColumn, aValue);
        }
        return lResult;
    };

    this.LiveExpressionModifier = function () {
        var lColumns = $.extend([], mThis.Columns);

        mThis.Columns = mThis.SecondaryColumns;
        mThis.Expression = buildPredicate();
        mThis.Columns = lColumns;
    }

    this.SetSecondaryColumns = function (aColumnList) {
        mThis.SecondaryColumns = aColumnList;
    }
    this.SetPrimaryColumns = function (aColumnList) {
        mThis.Columns = aColumnList;
    }

    //artf80456 update preferences on filter list after write user preferences - EE
    this.UpdatePreferences = function(aPreferences){
      aPreferences.map(function(preference){
        mThis.UserPreferences[preference.ColumnName] = preference;
      });
    }

}
FilterControl.prototype = new sumo.controls.ControlBase();
FilterControl.prototype.constructor = FilterControl;
FilterControl.prototype.baseClass = sumo.controls.ControlBase;
